import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote, ArrowRight, CheckCircle } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Carlos Mendoza',
    role: 'Marketing Digital',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=faces',
    quote: "La Biblia de Prompts es oro puro. Antes tardaba 2 horas en crear el contenido, hoy lo hice en 15 minutos. Solo por ese bono ya vale la pena."
  }, {
    name: 'Sofía Rodríguez',
    role: 'Project Manager',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=faces',
    quote: "Pensé que la IA era técnica, pero este kit lo hace súper fácil. Mis informes ahora se escriben solos y mi jefe está impresionado."
  }, {
    name: 'David López',
    role: 'Emprendedor',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=faces',
    quote: "La mejor inversión de $20 del año. La Toolbox Secreta tiene herramientas gratuitas que me han ahorrado cientos de dólares en suscripciones."
  }, {
    name: 'Elena Torres',
    role: 'Asistente Virtual',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&h=150&fit=crop&crop=faces',
    quote: "Estaba a punto de colapsar. La Checklist de Automatización ordenó mi día. Ahora termino a las 5 PM sin falta."
  }, {
    name: 'Javier Costa',
    role: 'Estudiante Universitario',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=faces',
    quote: "Usé el Masterkit para mi tesis. Lo que me iba a tomar semanas en análisis de datos, lo estructuré en una tarde. ¡Increíble!"
  },
  // NUEVO TESTIMONIO AGREGADO PARA COMPLETAR LA GRID
  {
    name: 'Mariana Ruiz',
    role: 'Creadora de Contenido',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=faces',
    quote: "Mis guiones de TikTok y Reels ahora tienen el doble de retención gracias a los prompts de viralidad. Esto se pagó solo el primer día."
  }];
  return <section className="py-24 bg-[#050505] relative overflow-hidden" data-id="element-194">
      {/* Fondo decorativo */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-5xl h-full bg-cyan-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-195" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-196">
        
        {/* Encabezado */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-197">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-198">
            RESULTADOS <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-500" data-id="element-199">REALES</span>
          </h2>
          <p className="text-xl text-gray-400" data-id="element-200">
            Únete a los profesionales que ya han recuperado su tiempo.
          </p>
        </div>

        {/* Grid Perfecta de 3 Columnas x 2 Filas */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-20" data-id="element-201">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: "-50px"
        }} transition={{
          delay: index * 0.1
        }} className="relative p-8 rounded-2xl bg-white/5 border border-white/10 hover:border-cyan-500/30 hover:bg-white/10 transition-all duration-300 group flex flex-col h-full" data-id="element-202">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-white/5 group-hover:text-cyan-500/20 transition-colors" data-id="element-203" />

              <div className="flex gap-1 mb-6" data-id="element-204">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-205" />)}
              </div>

              <p className="text-lg text-gray-300 mb-8 italic leading-relaxed flex-grow" data-id="element-206">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-4 border-t border-white/5 pt-6 mt-auto" data-id="element-207">
                <div className="relative" data-id="element-208">
                  <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-white/10 group-hover:border-cyan-500 transition-colors" data-id="element-209">
                    <img src={t.image} alt={t.name} className="w-full h-full object-cover" data-id="element-210" />
                  </div>
                  <div className="absolute -bottom-1 -right-1 bg-blue-500 rounded-full p-0.5 border-2 border-[#050505]" data-id="element-211">
                    <CheckCircle className="w-3 h-3 text-white" data-id="element-212" />
                  </div>
                </div>
                <div data-id="element-213">
                  <h4 className="font-bold text-white text-sm" data-id="element-214">{t.name}</h4>
                  <p className="text-cyan-400 text-xs font-medium uppercase tracking-wider" data-id="element-215">{t.role}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* CTA FINAL DE ALTO IMPACTO */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative max-w-4xl mx-auto mt-24 p-1 rounded-3xl bg-gradient-to-r from-cyan-500 via-blue-600 to-purple-600 shadow-2xl shadow-blue-500/20" data-id="element-216">
          <div className="bg-[#0a0a0a] rounded-[22px] p-8 md:p-12 text-center overflow-hidden relative" data-id="element-217">
            {/* Brillo de fondo */}
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-blue-500/10 to-transparent pointer-events-none" data-id="element-218" />
            
            <h3 className="text-2xl md:text-4xl font-bold text-white mb-4 relative z-10" data-id="element-219">
              ¿Listo para automatizar tu trabajo?
            </h3>
            <p className="text-gray-400 mb-8 max-w-2xl mx-auto relative z-10" data-id="element-220">
              El precio subirá pronto. Aprovecha el descuento de lanzamiento y llévate todos los bonos hoy.
            </p>
            
            <button className="relative z-10 px-10 py-5 rounded-full bg-white text-black font-black text-xl md:text-2xl hover:scale-105 hover:shadow-xl hover:shadow-cyan-500/20 transition-all flex items-center gap-3 mx-auto" data-id="element-221">
              DESCARGAR PACK AHORA - $19.99
              <ArrowRight className="w-6 h-6" data-id="element-222" />
            </button>
            
            <p className="mt-6 text-sm text-gray-500 flex items-center justify-center gap-2 relative z-10" data-id="element-223">
              <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-224" />
              Acceso inmediato a tu correo
            </p>
          </div>
        </motion.div>

      </div>
    </section>;
}